"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const icons_1 = require("../../assets/icons");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const components_1 = require("../../components");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const scale_1 = require("../../utils/scale");
const InfoItem = (props) => {
    const { title, content } = props;
    return (react_1.default.createElement(react_native_1.View, { style: styles.infoItem },
        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemTitle }, title),
        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, content)));
};
const CompanyInfo = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                alignSelf: "center",
            }, title: "会社概要", styleContainer: {
                backgroundColor: "white",
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setVisibleMenu(true);
            } }),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: [
                styles.body, {
                    paddingBottom: inset.bottom + (0, scale_1.scale)(100)
                }
            ], showsVerticalScrollIndicator: false },
            react_1.default.createElement(InfoItem, { title: '\u4F1A\u793E\u540D', content: `株式会社富士山マガジンサービス\nFujisan Magazine Service Co., Ltd.` }),
            react_1.default.createElement(InfoItem, { title: '\u6240\u5728\u5730', content: `〒150-0036\n東京都渋谷区南平台町16－11－7階(お客様受付）（京王井の頭線神泉駅より徒歩5分 渋谷駅より徒歩11分 代官山駅より徒歩13分 池尻大橋駅より徒歩13分）` }),
            react_1.default.createElement(InfoItem, { title: '\u8A2D\u7ACB', content: `2002年7月12日` }),
            react_1.default.createElement(InfoItem, { title: '\u8CC7\u672C\u91D1', content: `265,198千円（2022年12月末現在）` }),
            react_1.default.createElement(InfoItem, { title: '\u4E3B\u8981\u682A\u4E3B', content: `西野 伸一郎\n株式会社図書館流通センター\n神谷 アントニオ\n株式会社Catalyst・Data・Partners` }),
            react_1.default.createElement(react_native_1.View, { style: styles.infoItem },
                react_1.default.createElement(CustomText_1.default, { style: styles.infoItemTitle }, "\u5F79\u54E1\u69CB\u6210"),
                react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u4EE3\u8868\u53D6\u7DE0\u5F79\u4F1A\u9577"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u897F\u91CE \u4F38\u4E00\u90CE")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u4EE3\u8868\u53D6\u7DE0\u5F79\u793E\u9577"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u795E\u8C37 \u30A2\u30F3\u30C8\u30CB\u30AA")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u53D6\u7DE0\u5F79"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u4F50\u85E4 \u9244\u5E73")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u53D6\u7DE0\u5F79\uFF08\u793E\u5916\uFF09"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u9AD9\u6A4B \u8A89\u5247")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u5E38\u52E4\u76E3\u67FB\u5F79\uFF08\u793E\u5916\uFF09"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u4F0A\u85E4 \u4E09\u516B")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u76E3\u67FB\u5F79\uFF08\u793E\u5916\uFF09"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u9060\u5C71 \u5B5D\u4E4B")),
                    react_1.default.createElement(react_native_1.View, { style: styles.specialInfoContent },
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u76E3\u67FB\u5F79\uFF08\u793E\u5916\uFF09"),
                        react_1.default.createElement(CustomText_1.default, { style: styles.infoItemContent }, "\u6DF1\u753A \u5468\u8F14")))),
            react_1.default.createElement(InfoItem, { title: '\u5F93\u696D\u54E1\u6570', content: `80名(2022年12月末現在） 男性：35名、女性：45名` }),
            react_1.default.createElement(InfoItem, { title: '\u53D6\u5F15\u9280\u884C', content: `三菱UFJ銀行 渋谷中央支店\n三井住友銀行 東京中央法人営業第一部支店\nみずほ銀行 渋谷中央支店\nりそな銀行 東京中央支店` }),
            react_1.default.createElement(InfoItem, { title: '\u4E8B\u696D\u6982\u8981', content: `■お客様メリット「出合いを創出し、便利にお得に利用できます」日本には10,000タイトル以上の雑誌が存在しています。この全てのボリュームを書店が店頭で揃えることは、フロア面積の問題があり、とても難しいことだと言えます。また、10,000タイトル以上もあると、短時間で趣味性・専門性の高い雑誌に出合うことも現実的ではありません。しかしながら、雑誌に特化したオンライン書店の Fujisan.co.jpであれば、検索機能もあり、これらの問題は解決済みです。趣味や興味に応じた、新しい雑誌との新しい出合いがきっとあることでしょう。また、すでにお気に入りの雑誌があるなら、定期購読の利用こそ Fujisan.co.jpを利用する最大のメリットです。出版社によって異なる申し込み方法、決済手段、問い合わせなどの窓口を弊社で一本化できるのです。さらに、割引価格で購読ができる雑誌も多数用意しています。お客様は、より便利に、より簡単に、よりお得に、雑誌のある生活をお楽しみいただけます。\n■出版社様メリット「求められる雑誌を求めるひとへ」Fujisan.co.jpは、「求められる雑誌を求めるひとへ」のコンセプトに基づき、定期購読に特化したマーケティングを、SEOを最適化するなどしつつ広く展開しています。これにより、出版社様が単独では難しかった潜在的な読者へのリーチが可能です。また、月あたりのユーザー数は、じつに 200万UUを数えます。創業より20年間、有名人気雑誌だけでなく、多数の業界専門誌を揃え続けていることで「雑誌を買うなら富士山」という雑誌販売プラットフォームが、市場に認知されたことの証左とも言えます。当社の配送を含めた顧客CRMの提供は、ご利用いただく積極的な理由になっています。たとえば、出版個社で定期購読を運用する場合、個人情報管理・人材のアサイン・割高になりがちな配送料対応・各種お客様問い合わせなど、業務範囲が膨大になってしまうところ、当社であれば、ワンストップかつ割安価格で提供できるのです。もちろん当社は、個人情報を適切に扱っている企業に与えられる「プライバシーマーク」を取得済みです。\n■法人様メリット「部門や支店を超えた一元管理を提供」複数の雑誌を定期的に購入する場合、任意の書店や出版社と個別に取引するか、 Fujisan.co.jpでまとめて購読管理をするか。業務効率化の観点だけでなく、「割引価格が適用される」となればどうでしょう。もはやFujisan.co.jpを選ばない理由が見当たりません。さらに、大手法人様からは、特にコンプライアンスの観点で、これまで各部門・各支店・各営業所で個別に購入していた雑誌について、当社システムを利用することで、明細を「見える化」し、一元管理できるとたいへん好評です。また、近年では、社員の方々への福利厚生・社員教育ツールとして、Fujisan.co.jpを利用した定期購読をご利用いただくことも増えています。雑誌は世の中のトレンドを映すツールという側面をもっています。顧客とのサービス接点が多数ある法人様からは「いまおすすめの雑誌」「品揃え」について当社に事前に相談をしたいという要望も増え続けており、これにお応えしています。詳しくはお問い合わせください。\n■当社がご提供できる各種サービス（まとめ）・定期購読誌を中心とした雑誌の販売業務・定期購読誌の梱包・配送業務・定期購読者の顧客管理業務・定期購読に関するカスタマーサポート業務・定期購読全般のコンサルティング業務` }),
            react_1.default.createElement(react_native_1.View, { style: styles.infoItem },
                react_1.default.createElement(CustomText_1.default, { style: styles.infoItemTitle }, "\u63A1\u7528"),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, onPress: () => react_native_1.Linking.openURL('https://www.fujisan.co.jp/recruit/') },
                    react_1.default.createElement(CustomText_1.default, { style: styles.linkInfoItemContent }, "\u63A1\u7528\u60C5\u5831\u30DA\u30FC\u30B8"),
                    react_1.default.createElement(icons_1.IC_REDIRECT, null)))),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) })));
};
exports.default = CompanyInfo;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f7f7f7'
    },
    body: {
        paddingTop: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    infoItem: {
        width: '100%',
        flexDirection: 'row',
        paddingVertical: (0, scale_1.scale)(12),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    infoItemTitle: {
        width: (0, scale_1.scale)(80),
        paddingRight: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    specialInfoContent: {
        width: '100%',
        flexDirection: 'row'
    },
    infoItemContent: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    linkInfoItemContent: {
        color: '#007AFF',
        marginRight: (0, scale_1.scale)(2),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    }
});
